// @ts-nocheck
import { createStyle } from '@gluestack-style/react';

export const AvatarImage = createStyle({
  w: '$full',
  h: '$full',
  borderRadius: '$full',
  position: 'absolute',
});
